export default "__VITE_ASSET__COigE3Md__"